import React, { useState, useEffect, useContext, useRef, useMemo } from 'react'
import UserContext from 'contexts/UserContext'
import { getListBeneficary } from 'requests/benificary'
import classNames from 'classnames'
import { Spinner } from 'utils/loading'
import { useNavigate } from 'react-router-dom'
import IconSelectInput from '../../assets/iconTsx/DropDown'

import BeneficiaryContext from 'contexts/beneficiaryContext'
import ModalBeneficiary from 'containers/beneficiaireContainer/modalBeneficiary'
import ModalAddBeneficiary from 'containers/beneficiaireContainer/modalAddBeneficiary'
import iconAddBnf from '../../assets/iconAddBnf.svg'
import LogoOrangeMoney from '../../assets/logoOrangeMoney.svg'
import LogoPaisa from '../../assets/logopaisaWallet.svg'
import LogoJazz from '../../assets/logojazzWallet.svg'

import transferBeneficiaryContext from 'contexts/transferBeneficiaryContext'
import ModaleWallet from 'containers/transfert-vers-wallet/modaleWallet'
import ModalTestStatusUser from 'components/modalTestStatusUser'
import Avatar from 'components/avatar'
import InputSelectComponent from 'components/inputSelectComponent'
import { LogoAirtel, LogoCoins, LogoEquitel, LogoGCash, LogoGrap, LogoMaya, LogoMpesa } from 'assets/logoModal'

interface listeOption {
  id: string
  value?: string
  image?: string
  code?: string
}
interface Beneficiary {
  _id: string
  avatar: string
  bankName: string
  bankCode: string
  identifiantCardNumber: string
  accountNumber: string
  SWIFTBIC: string
  relationship: string
  sender: string
  paytopBeneficiaryId: string
  personalInfo: {
    firstName: string
    lastName: string
    gender: string
    phone: {
      prefix: string
      number: string
    }
  }
}

interface props {
  paysCode: string
  setBenificiareId: (name: string) => void
  motif: string
  setMotif: (value: string) => void
  setNumStep: (value: number) => void
  setIdBeneficiary: (value: any) => void
  idBeneficiary: any
  apiData?: any
  setColectPointId?: (value: any) => void
  colectPointId?: any
  setSelectedBnfList: (value: any) => void
  selectedBnfList: any
  // setSelectedOperateur?: (value: string) => void
  // selectedOperateur?: string
  valuePays: any
  functionTracks: any
  pathCode: any
  selectedValue?: string
  isWallet?: boolean
}

const Benefiaire: React.FC<props> = ({
  paysCode,
  setBenificiareId,
  motif,
  setMotif,
  setNumStep,
  setIdBeneficiary,
  idBeneficiary,
  apiData,
  setColectPointId,
  colectPointId,
  setSelectedBnfList,
  selectedBnfList,
  // setSelectedOperateur,
  // selectedOperateur = '',
  valuePays,
  functionTracks,
  pathCode,
  selectedValue,
  isWallet = false,
}) => {
  const { user } = useContext(UserContext)
  const { TransferData, setTransferData } = useContext(transferBeneficiaryContext)
  const [loading, setLoading] = useState(false)
  const [dataBeneficiaries, setBeneficiariesData] = useState<Beneficiary[]>([])
  // const [people, setPeople] = useState<Beneficiary[]>([])
  const [isOpenMotif, setIsOpenMotif] = useState(false)
  const [isOpenWallet, setIsOpenWallet] = useState(false)
  const [isOpenBnflist, setIsOpenBnflist] = useState(false)
  const COUNTRY_MAP: Record<string, string> = {
    TND: '216',
    XOF: '221',
    MAD: '212',
    PKR: '92',
    BDT: '880',
    TRY: '90',
    NGN: '234',
    KES: '254',
    PHP: '63',
  }

  const itemsMotif = [
    { id: 0, code: 'FAMILY_SUPPORT', value: 'Aide Familiale' },
    { id: 1, code: 'OTHER_FEES', value: 'Frais' },
    { id: 2, code: 'PROPERTY_PURCHASE', value: 'Paiement' },
    { id: 3, code: 'OTHER', value: 'Autres non répertoriés' },
  ]
  const listeWallet = [
    { codePays: 'PKR', value: 'Jazz Cash Wallet', label: 'Jazz Cash Wallet', image: LogoJazz },
    { codePays: 'PKR', value: 'Easy Paisa Wallet', label: 'Easy Paisa Wallet', image: LogoPaisa },
    { codePays: 'XOF', value: 'Orange Money ', label: 'Orange Money Senegal', image: LogoOrangeMoney },
    { codePays: 'PHP', value: 'Coins ', label: 'Coins.ph', image: LogoCoins },
    { codePays: 'PHP', value: 'Maya ', label: 'PayMaya', image: LogoMaya },
    { codePays: 'PHP', value: 'GCash ', label: 'GCash', image: LogoGCash },
    { codePays: 'PHP', value: 'GrabPay ', label: 'GrabPay', image: LogoGrap },
    { codePays: 'KES', value: 'M-Pesa ', label: 'M-Pesa', image: LogoMpesa },
    { codePays: 'KES', value: 'Airtel Money ', label: 'Airtel Money', image: LogoAirtel },
    { codePays: 'KES', value: 'Equitel Money ', label: 'Equitel Money', image: LogoEquitel },
  ]

  const [selectedOptionMotif, setSelectedOptionMotif] = useState(
    itemsMotif.find((item) => item.code === TransferData)?.value || '',
  )
  const [selectedOptioWallet, setSelectedOptionWallet] = useState(
    // valuePays.value==='XOF'? 'Orange Money ':
    TransferData?.valuePays === 'XOF' ? 'Orange Money ' : TransferData?.operateurWallet || '',
  )

  const [isAdded, setIsAdded] = useState(false)
  const [openModalWallt, setOpenModalWallet] = useState(false)

  const statusComplete = user?.user?.status === 'confirmed' && user?.user?.isDocumentSent
  const statusPending = user?.user?.status === 'pending' && user?.user?.isDocumentSent
  const statusNotFound = user?.user?.status === 'pending' && !user?.user?.isDocumentSent
  const [openIsModalStatus, setOpenIsModalStatus] = useState(false)
  const navigate = useNavigate()

  const [iconWallet, setIconWallet] = useState('')

  const listeSelectWallet = listeWallet.filter((item) => item.codePays === (TransferData?.valuePays || ''))

  useEffect(() => {
    if (TransferData?.valuePays === 'XOF') {
      setIconWallet(LogoOrangeMoney)
      return
    }

    const wallet = listeSelectWallet.find((item) => item.value === TransferData?.operateurWallet)

    setIconWallet(wallet?.image || '')
  }, [TransferData?.valuePays])

  useEffect(() => {
    async function fetchData() {
      const id = user?.user?._id
      const token = user?.token?.accessToken
      const response = await getListBeneficary(id, token)
      if (response?.success === true) {
        setBeneficiariesData(response?.beneficiaries)
        setLoading(true)
      }
    }
    if (user) {
      fetchData()
    }
  }, [user, isAdded])

  const filteredBeneficiaries = useMemo<listeOption[]>(() => {
    return dataBeneficiaries
      .filter(
        (bnf) => bnf.personalInfo.phone.prefix === COUNTRY_MAP[TransferData?.valuePays || '216'],
        // (bnf): bnf is Beneficiary =>
        // !!bnf?.personalInfo &&
        // typeof bnf.personalInfo.firstName === 'string' &&
        // typeof bnf.personalInfo.lastName === 'string' &&
        // (
        //   (valuePays.value === 'MAD' && ['+212', '212'].includes(bnf.personalInfo.phone?.prefix ?? '')) ||
        //   (valuePays.value === 'TND' && ['+216', '216'].includes(bnf.personalInfo.phone?.prefix ?? '')) ||
        //   (valuePays.value === 'XOF' && ['+221', '221'].includes(bnf.personalInfo.phone?.prefix ?? ''))
        // )
      )
      .map((item) => ({
        id: item._id,
        value: `${item.personalInfo.firstName} ${item.personalInfo.lastName}`,
        image: item.avatar,
      }))
  }, [dataBeneficiaries, valuePays.value])

  const openModalStatus = () => {
    setOpenIsModalStatus(true)
  }
  const closeModalStatus = () => {
    setOpenIsModalStatus(false)
  }

  const handleSelectMotif = (option: any) => {
    setSelectedOptionMotif(option.value)
    setTransferData({ ...TransferData, Motif: option.code })
    setMotif(option.code)
  }

  const handleSelectWallet = (option: any) => {
    setSelectedOptionWallet(option.label)
    setIconWallet(option.image)
    setTransferData({ ...TransferData, operateurWallet: option.label })
  }
  const handleSelectbnf = (bnf: listeOption) => {
    const extraireBenif = dataBeneficiaries.find((item) => item._id === bnf.id)

    setSelectedBnfList(`${extraireBenif?.personalInfo?.firstName} ${extraireBenif?.personalInfo?.lastName}`)
    setIdBeneficiary(extraireBenif?._id)
    setTransferData({
      ...TransferData,
      BeneficiaryName: `${extraireBenif?.personalInfo?.firstName} ${extraireBenif?.personalInfo?.lastName}`,
      idBeneficiary: extraireBenif?._id,
      phoneNumberBeneficiary: `${extraireBenif?.personalInfo.phone.prefix} ${extraireBenif?.personalInfo.phone.number} `,
      cinBeneficiary: extraireBenif?.identifiantCardNumber,
      numBankBeneficiary: extraireBenif?.accountNumber,
      banqueName: extraireBenif?.bankName,
      bankcode: extraireBenif?.bankCode,
      swiftBic: extraireBenif?.SWIFTBIC,
      valuePays: valuePays.value,
      codeIso: paysCode,
      governorate: '',
      partenaire: '',
      ville: '',
      avatar: extraireBenif?.avatar,
    })
  }

  useEffect(() => {
    if (TransferData) {
      setSelectedBnfList(TransferData?.BeneficiaryName)
      setIdBeneficiary(TransferData?.idBeneficiary)
      setSelectedOptionMotif(itemsMotif.find((item) => item.code === TransferData.Motif)?.value || '')
      // setSelectedOptionMotif(TransferData?.Motif)
      setMotif(TransferData?.Motif || '')
    }
  }, [TransferData])

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)

  const openModal = () => {
    setIsModalOpen(true)
  }

  const closeModal = () => {
    setIsModalOpen(false)
  }
  useEffect(() => {
    setTransferData({
      ...TransferData,
      currentPath: '',
    })
  }, [])

  if (!loading) return <Spinner name="line-scale-pulse-out-rapid" color="#1466ff" />
  return (
    <div
      className="flex flex-col gap-5 w-full justify-center"
      onClick={() => {
        if (isOpenBnflist || isOpenMotif) {
          ;(setIsOpenBnflist(false), setIsOpenMotif(false))
        }
      }}
    >
      {isWallet && (
        <div className=" w-full h-[100px]">
          <InputSelectComponent
            liste={listeSelectWallet}
            isOpen={isOpenWallet}
            setIsOpen={setIsOpenWallet}
            value={selectedOptioWallet}
            setValue={setSelectedOptionWallet}
            icon={iconWallet}
            placeholder="Sélectionnez l’opérateur"
            label="Sélectionnez l’opérateur"
            handleClick={handleSelectWallet}
          />
        </div>
      )}

      {/* <h2 className='h2'>Choisissez votre bénéficiaire</h2> */}
      <div className="flex justify-between items-end gap-5 w-full">
        <div className="w-full">
          <InputSelectComponent
            liste={filteredBeneficiaries}
            isOpen={isOpenBnflist}
            setIsOpen={setIsOpenBnflist}
            value={selectedBnfList}
            setValue={setSelectedBnfList}
            placeholder={filteredBeneficiaries.length===0 ? 'Pas de bénéficiaire' : 'Bénéficiaires'}
            label="Bénéficiaire du transfert"
            icon={TransferData?.avatar}
            avatar="{TransferData?.avatar}"
            handleClick={handleSelectbnf}
            isDropDown={filteredBeneficiaries.length===0 ? false : true}
          />
        </div>

        <div className="flex flex-col items-center">
          <img
            src={iconAddBnf}
            className="  sm:w-12 sm:h-12 w-[36px] h-[36px] hover:cursor-pointer"
            width={56}
            height={56}
            onClick={openModal}
          />
          <span className="text-[#5754E5] text-[12px] font-medium font-roboto pt-1">Ajouter</span>

          <ModalBeneficiary isOpen={isModalOpen} closeModal={closeModal}>
            <ModalAddBeneficiary
              closeModal={closeModal}
              setIsAdded={() => setIsAdded(!isAdded)}
              valuePays={valuePays}
              isOpenListPays={false}
              code={pathCode}
              isAddToContext
            />
          </ModalBeneficiary>
        </div>
      </div>

      <InputSelectComponent
        liste={itemsMotif}
        isOpen={isOpenMotif}
        setIsOpen={setIsOpenMotif}
        value={selectedOptionMotif}
        setValue={setSelectedOptionMotif}
        placeholder="Motif"
        label="Motif du transfert"
        handleClick={handleSelectMotif}
      />

      {isWallet && (
        <span className="text-[#6B7280] mt-10 text-[14px] ">
          * Assurez-vous de vérifier soigneusement le numéro de téléphone du bénéficiaire avant d’effectuer le
          transfert. En cas d’erreur, il pourrait être difficile, voire impossible, d’obtenir un remboursement par la
          suite. Nous vous recommandons de prendre cette précaution afin de garantir une transaction sans encombre.
        </span>
      )}

      <div className="flex gap-[16px] mt-[25px] justify-center w-full h-[56px] sm:px-4 font-semibold font-roboto ">
        <button
          className={classNames(
            'text-[18px] text-[#5754E5] hover:bg-[#F1F1FF]   border border-[#5754E5] w-[180px] sm:w-[140px] rounded-[16px]',
          )}
          onClick={() => {
            setNumStep(0)
          }}
        >
          Précédent
        </button>
        {!isWallet ? (
          <button
            className={classNames(
              !TransferData?.BeneficiaryName || !TransferData.Motif
                ? 'bg-[#D1D1FF] hover:cursor-not-allowed'
                : 'bg-[#5754E5] hover:cursor-pointer hover:bg-[#4D36CC]',
              'text-[18px] text-[#FFF]   sm:w-[170px]  rounded-[16px] w-[375px]  ',
            )}
            onClick={() => {
              if (!isWallet) {
                setNumStep(2)
                functionTracks('2')
              } else if (isWallet) {
                if (statusComplete) {
                  setOpenModalWallet?.(true)
                } else if (statusPending) {
                  openModalStatus()
                } else if (statusNotFound) {
                  navigate('/personalinformation')
                }
              }
            }}
            disabled={!TransferData?.BeneficiaryName || !TransferData.Motif}
          >
            Suivant
          </button>
        ) : (
          <button
            className={classNames(
              !TransferData?.BeneficiaryName || !TransferData.Motif || !TransferData.operateurWallet
                ? 'bg-[#D1D1FF] hover:cursor-not-allowed'
                : 'bg-[#5754E5] hover:cursor-pointer hover:bg-[#4D36CC]',
              'text-[18px] text-[#FFF]   sm:w-[170px]  rounded-[16px] w-[375px]  ',
            )}
            onClick={() => {
              if (!isWallet) {
                setNumStep(2)
                functionTracks('2')
              } else if (isWallet) {
                if (statusComplete) {
                  setOpenModalWallet?.(true)
                } else if (statusPending) {
                  openModalStatus()
                } else if (statusNotFound) {
                  navigate('/personalinformation')
                }
              }
            }}
            disabled={!TransferData?.BeneficiaryName || !TransferData.Motif || !TransferData.operateurWallet}
          >
            Suivant
          </button>
        )}
      </div>
      {openModalWallt && (
        <div className="">
          <ModaleWallet isClose={setOpenModalWallet} isConfirme={functionTracks} setNumStep={setNumStep} />
        </div>
      )}

      <ModalTestStatusUser
        isOpen={openIsModalStatus}
        closeModal={closeModalStatus}
        statusPending={statusPending}
        statusNotFound={statusNotFound}
      />
    </div>
  )
}
export default Benefiaire
